import FAQSection from 'components/FAQSection';
import {NextSeo} from 'next-seo';
import GetStartedFooterSection from 'components/GetStartedFooterSection';
import CalendlyEmbed from 'components/CalendlyEmbed';

export default function ScheduleCallPage() {
  return (
    <>
      <NextSeo title="Schedule a call | Polar Signals" />
      <div className="flex flex-col">
        <CalendlyEmbed />
        <FAQSection />
        <GetStartedFooterSection />
      </div>
    </>
  );
}
